module.exports = __webpack_public_path__ + "img/familia.c9695218.png";